/**
 * 图片上传指令
 * opt: {
  *   maxEdge 压缩后最大边长 默认1280（长边超出时等比缩小）
  *   quality 重新编码质量 默认0.8（JPEG）
  *   notCompress 是否跳过压缩（如需 OCR 识别的清晰照片）默认false
  *   fileFormat 图片格式过滤
 * }
 */
// 公共图片压缩工具（先压缩、再上传）
import { compressImage } from '../../src/commons/imageCompress'
// 图片上传接口（与 src/configs/config.js 的 apiFilter 保持一致：通过页面 origin 区分生产/测试环境）
const UPLOAD_URL = {
  prod: 'https://api.hzqmtech.com/admin/common/upload', // 生产
  test: 'https://test-api.hzqmtech.com/admin/common/upload' // 测试
}
// 生产环境：正式站点（用 hostname 判断，兼容 http/https）
const isProdEnv = location.hostname === 'm.hzqmtech.com'
const uploadUrl = isProdEnv ? UPLOAD_URL.prod : UPLOAD_URL.test
const vinGetPic = 'https://www.xiaokunkeji.cn/api/vin/image/ocr' // 本项目没用到，所以没修改
// 类实例
let instance = null
// FileReader
let fileReader = null

class ImgUpload {
  static upload(opts = Object) {
    opts = Object.assign({
      // fileFormat: ['png', 'jpg', 'jpeg']
      quality: 0.8,
      maxSize: 1024 * 1024 * 8 // 超过 8MB 才压缩，不超过直接上传原文件（不修改尺寸）
	}, opts)

	this.opts = opts

    if (!instance) {
      instance = new ImgUpload()
    }
    return instance.uploadImg(opts)
  }

  constructor() {
    this.onLoadImgSuccess = null
    this.opts = null
  }

  async uploadImg(opts) {
    // 实例上同步保存配置（static upload 里的 this 是类本身，实例读不到）
    this.opts = opts

    // 过滤错误调用
    if (opts.file.length === 0) {
      Promise.reject({
        _code: -1,
        _message: '未选择图片或者取消选择图片'
      })
    }

    // img
    let file = opts.file[0]

    // 过滤文件格式
    if (opts.fileFormat && !opts.fileFormat.includes(file.name.match(/\.(\w+)$/)[1])) {
      Promise.reject({
        _code: -2,
        _message: '文件格式不正确'
      })
    }

    // 回调(兼容1.0)
    this.onLoadImgSuccess = opts.onLoadImgSuccess || opts.onImgSuccess

    // 未压缩分支单独触发回调（保持原有钩子行为）
    if (opts.notCompress && this.onLoadImgSuccess) {

      const fileResult = await instance._fileReader(file)

      // 触发回调
      this.onLoadImgSuccess({
        img: fileResult
      })
    }

    // 上传前统一压缩：等比缩放到最大边长后按指定质量重新编码
    // notCompress 为 true 时跳过（如需 OCR 车牌识别的清晰照片）
    if (!opts.notCompress) {
      file = await instance._imgCompress(file)
      // 处理超时：终止上传，返回失败结果（compressImage 内已提示"处理失败"）
      if (!file) {
        return {
          code: '500',
          message: '图片处理失败，请重试'
        }
      }
    }

    // 上传
    return instance._upload(file, opts)
  }

  async _imgCompress(file) {

    // load文件流
    const fileResult = await instance._fileReader(file)

    // 触发回调
    this.onLoadImgSuccess && this.onLoadImgSuccess({

      img: fileResult

    })

    // 图片压缩（保持原尺寸，仅降低质量重新编码），失败或体积未变小时返回原文件
    const opts = this.opts || {}
    return compressImage(file, {
      quality: opts.quality,
      maxSize: opts.maxSize
    })
  }

  async _fileReader(file) {

    return new Promise((resolve, reject) => {

      if (!fileReader) {
        fileReader = new FileReader()
      }

      fileReader.onloadend = () => {
        resolve(fileReader.result)
      }

      fileReader.onerror = () => {

        reject({
          _code: -3,
          _message: '文件load失败'
        })

      }

      fileReader.readAsDataURL(file)

    })

  }

  async _upload(img, opts) {
    const data = new FormData()

	data.append('multipartFile', img)

	tuhu.showIndicator()

	if (opts.vin) { // 图片识别
		const res = await tuhu.fetch(vinGetPic, {
			method: 'post',
			body: data
		}, {
			timeout: 20
		}).catch(() => {
			Promise.reject({
			  _code: -6,
			  _message: '接口异常'
			})
		})

		return Object.assign({ index: opts.index }, res || {})

	} else { // 图片上传

		const res = await tuhu.fetch(uploadUrl, {
			method: 'POST',
			body: data
		}, {
			timeout: 2000
		}).catch(() => {
			Promise.reject({
			  _code: -6,
			  _message: '接口异常'
			})
		})

		tuhu.hideIndicator()
		return Object.assign({ index: opts.index }, res || {})
	}
  }
}

export default ImgUpload



// WEBPACK FOOTER //
// ./lib/commons/upload.js